import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSlash } from '@fortawesome/pro-solid-svg-icons';

// actions
import { endCall } from '../../../../actions/telephony';

function EndCall({
  className = '',
  style = {},
}) {
  return (
    <button
      type="button"
      className={['btn btn-danger', className].join(' ')}
      style={{
        borderRadius: '17px',
        color: 'white',
        ...style,
      }}
      onClick={endCall}
    >
      End call
      <FontAwesomeIcon className="ms-2" icon={faPhoneSlash} />
    </button>
  );
}

export default EndCall;
